// extracted by mini-css-extract-plugin
export default {"icon":"style--icon--91fc83","new":"style--new--16dce9","rescheduled":"style--rescheduled--56d984","cancelled":"style--cancelled--979901"};